<ng-template #loading>
  <app-mat-spinner-overlay text="Henter sak..."></app-mat-spinner-overlay>
</ng-template>

<ng-template #loadingOrError>

  <ng-container *ngIf="errorObject; else loading">
    <div class="flex-row">
      {{errorObject}}
    </div>
  </ng-container>

</ng-template>


<div *ngIf="case && data; else loading" class="flex-column flex-gap-20">

  <h1>{{getLabelValue('Title') | striphtml}}</h1>

  <p *ngIf="case.IsClientPaperless" [innerHtml]="getLabelValue('CaseDetailsInfo') | safe: 'html'"></p>

  <!-- header -->
  <div>
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{getLabelValue('CaseDetailsHeader') | striphtml}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="flex-grow flex-row flex-gap-20">

          <div class="flex-grow flex-column flex-gap-5">
            <label><strong>FinKn ref</strong></label>
            <span>{{case.CaseId}}</span>
          </div>

          <div class="flex-grow flex-column flex-gap-5">
            <label><strong>FinKN status</strong></label>
            <span>{{case.StatusFriendlyName}}</span>
          </div>

          <div class="flex-grow flex-column flex-gap-5">
            <label><strong>Meldt dato</strong></label>
            <span>{{case.RegDate | date: 'dd.MM.yyyy'}}</span>
          </div>

        </div>

      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="showAlertInfo">
    <div class="alert-warning">
      {{case.StatusFriendlyName}}
    </div>
  </div>

  <!-- No elkom message -->
  <div *ngIf="!case.IsClientPaperless">
    <div class="alert-warning" [innerHtml]="getLabelValue('CaseDetailsNoElKom') | safe: 'html'">
    </div>
  </div>

  <div *ngIf="case.HasContactInvitation">
    <div class="alert-warning" [innerHtml]="getLabelValue('CaseDetailsChangeContactInfo') | safe: 'html'"></div>
  </div>

  <form [formGroup]="caseForm" novalidate *ngIf="case?.IsClientPaperless">
    <div class="flex-column flex-gap-20">

      <!-- OPPLYSNINGER OM KONTAKTPERSON, HVIS KLAGER HAR DET -->
      <mat-card *ngIf="case?.HasCorrespondent">
        <mat-card-header>
          <mat-card-title>{{getLabelValue('CaseDetailsCorrespondent') | striphtml}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="flex-grow flex-column flex-gap-20">

            <!-- fornavn/etternavn -->
            <div class="flex-row flex-gap-20">
              <div class="flex-half flex-gap-10">
                <mat-form-field class="flex-grow">
                  <mat-label>{{getAlternativePlaceholder('Fornavn', false)}}</mat-label>
                  <input matInput formControlName="correspondentFirstName" autocomplete="given-name">
                  <mat-error>{{getAlternativePlaceholder('Fornavn', false)}} er et obligatorisk felt</mat-error>
                </mat-form-field>

                <mat-form-field class="flex-grow" *ngIf="case?.Correspondent?.IsFirm">
                  <mat-label>Organisasjonsnr</mat-label>
                  <input matInput formControlName="correspondentOrgNr" autocomplete="organization">
                </mat-form-field>
              </div>
              <div class="flex-half">
                <mat-form-field class="flex-grow">
                  <mat-label>{{getAlternativePlaceholder('Etternavn', false)}}</mat-label>
                  <!-- husk alternative label her -->
                  <input matInput formControlName="correspondentLastName" autocomplete="family-name">
                  <mat-error>{{getAlternativePlaceholder('Etternavn', false)}} er et obligatorisk felt</mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- adresse/kontaktinfo -->
            <div class="flex-row flex-gap-20">

              <!-- Adresseinformasjon -->
              <div class="flex-column flex-half flex-gap-10">

                <mat-form-field class="flex-grow"
                  *ngIf="caseForm?.controls?.correspondentCountryCodeAlpha2?.value === 'NO'">
                  <mat-label>Adresse</mat-label> <!-- husk alternative label her -->
                  <input matInput formControlName="correspondentAddress" autocomplete="street-address">
                  <mat-error
                    *ngIf="caseForm?.controls?.correspondentAddress?.errors && caseForm?.controls?.correspondentAddress?.errors?.required">Adresse
                    er et obligatorisk felt</mat-error>
                  <mat-error
                    *ngIf="caseForm?.controls?.correspondentAddress?.errors && caseForm?.controls?.correspondentAddress?.errors?.maxlength">Adresse
                    kan maksimalt inneholde
                    {{caseForm.controls.correspondentAddress.errors?.maxlength.requiredLength}} tegn</mat-error>
                </mat-form-field>

                <mat-form-field class="flex-grow"
                  *ngIf="caseForm?.controls?.correspondentCountryCodeAlpha2?.value !== 'NO'">
                  <mat-label>Utenlandsk adresse</mat-label>
                  <textarea style="height:107px;" matInput formControlName="correspondentAddress"></textarea>
                  <mat-error
                    *ngIf="caseForm?.controls?.correspondentAddress?.errors && caseForm?.controls?.correspondentAddress?.errors?.required">Adresse
                    er et obligatorisk felt</mat-error>
                  <mat-error
                    *ngIf="caseForm?.controls?.correspondentAddress?.errors && caseForm?.controls?.correspondentAddress?.errors?.maxlength">Adresse
                    kan maksimalt inneholde
                    {{caseForm.controls.correspondentAddress.errors?.maxlength.requiredLength}} tegn</mat-error>
                </mat-form-field>

                <div class="flex-row flex-gap-10"
                  *ngIf="caseForm?.controls?.correspondentCountryCodeAlpha2?.value === 'NO'">
                  <mat-form-field style="flex: 0 1 100px">
                    <mat-label>Postnr</mat-label> <!-- husk alternative label her -->
                    <input matInput formControlName="correspondentPostalCode" autocomplete="postal-code">
                    <mat-error>Postnr er et obligatorisk felt</mat-error>
                  </mat-form-field>

                  <mat-form-field class="flex-grow">
                    <mat-label>Poststed</mat-label> <!-- husk alternative label her -->
                    <input matInput formControlName="correspondentPostalPlace">
                    <mat-error>Poststed er et obligatorisk felt</mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="flex-grow">
                  <mat-label>Land</mat-label>
                  <mat-select formControlName="correspondentCountryCodeAlpha2">
                    <mat-option *ngFor="let countryCode of filteredCountries | async" [value]="countryCode.cca2">
                      {{countryCode.name.common}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Kontaktinformasjon -->
              <div class="flex-column flex-half flex-gap-10">

                <!-- husk alternative label her -->
                <div class="flex-row flex-gap-10">
                  <mat-form-field style="flex: 0 1 180px">
                    <mat-label>Landkode</mat-label>
                    <mat-select formControlName="correspondentPhoneCountryCodeAlpha2">
                      <mat-select-trigger>
                        {{getPhoneDisplayValueFromCountryCode(caseForm.controls['correspondentPhoneCountryCodeAlpha2'].value,
                        false)}}
                      </mat-select-trigger>
                      <mat-option *ngFor="let country of filteredCountries | async" [value]="country.cca2">
                        {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="flex-grow">
                    <mat-label>Telefon/mobil</mat-label>
                    <input matInput formControlName="correspondentPhone" autocomplete="tel">
                    <mat-error *ngIf="caseForm.controls.correspondentPhone?.errors?.phoneFormatError">Ugyldig
                      telefonnummer</mat-error>
                    <mat-error *ngIf="caseForm.controls.correspondentPhone?.errors?.required">Telefonnummer er et
                      obligatorisk felt</mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="flex-grow">
                  <mat-label>E-postadresse</mat-label> <!-- husk alternative label her -->
                  <input matInput formControlName="correspondentEmail" autocomplete="email">
                  <mat-error
                    *ngIf="caseForm.controls.correspondentEmail?.errors && caseForm.controls.correspondentEmail?.errors?.required">E-postadresse
                    er et obligatorisk felt</mat-error>
                  <!-- <mat-error
                    *ngIf="caseForm.controls.correspondentEmail?.errors && caseForm.controls.correspondentEmail?.errors?.email">Ugyldig
                    e-postadresse</mat-error> -->
                    
                  <mat-error
                    *ngIf="caseForm.controls.correspondentEmail?.errors && caseForm.controls.correspondentEmail?.errors?.maxlength">E-postadresse
                    kan maksimalt inneholde {{caseForm.controls.correspondentEmail.errors?.maxlength.requiredLength}}
                    tegn </mat-error>
                </mat-form-field>

                <mat-form-field class="flex-grow">
                  <mat-label>Referanse</mat-label> <!-- husk alternative label her -->
                  <input matInput formControlName="correspondentReference">
                  <mat-error
                    *ngIf="caseForm.controls.correspondentReference?.errors && caseForm.controls.correspondentReference?.errors?.maxlength">Referanse
                    kan maksimalt inneholde
                    {{caseForm.controls.correspondentReference.errors?.maxlength.requiredLength}} tegn </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="flex-row flex-gap-20">

              <button *ngIf="!case?.IsComplainer && !editModeCorrespondent" style="flex: 0 1 150px" class="finkn-btn"
                color="primary" mat-raised-button type="button"
                (click)="toggleEditModeCorrespondent(true)">Endre</button>

              <div class="flex-grow flex-row flex-gap-20" *ngIf="editModeCorrespondent">
                <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                  (click)="saveCorrespondent()">Lagre</button>
                <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                  (click)="cancelEditModeCorrespondent()">Avbryt</button>
              </div>

              <button *ngIf="case?.HasCorrespondent && !editModeCorrespondent" type="button" class="finkn-btn"
                color="primary" mat-raised-button (click)="changeContact()">Bytt kontaktperson</button>

              <button *ngIf="!editModeCorrespondent" type="button" class="finkn-btn" color="primary" mat-raised-button
                (click)="removeContact()">Fjern kontaktperson
              </button>

            </div>
          </div>

        </mat-card-content>
      </mat-card>

      <div *ngIf="case.HasComplainerInvitation">
        <div class="alert-warning" [innerHtml]="getLabelValue('ComplainerInvitationWaiting') | safe: 'html'"></div>
      </div>

      <!-- OPPLYSNINGER OM KLAGER -->
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{getLabelValue('CaseDetailsClient') | striphtml}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="flex-grow flex-column flex-gap-20">

            <!-- fornavn/etternavn -->
            <div class="flex-row flex-gap-20">

              <div class="flex-half flex-gap-10">
                
                <mat-form-field class="flex-grow">
                  <mat-label>{{getAlternativePlaceholder('Fornavn', true)}}</mat-label>
                  <!-- husk alternative label her -->
                  <input matInput [placeholder]="getAlternativePlaceholder('Fornavn', true)" formControlName="firstName"
                    autocomplete="given-name">
                  <mat-error>{{getAlternativePlaceholder('Fornavn', true)}} er et obligatorisk felt</mat-error>
                </mat-form-field>

                <mat-form-field class="flex-grow" *ngIf="case?.Complainer?.IsFirm">
                  <mat-label>Organisasjonsnr</mat-label>
                  <input matInput formControlName="orgnr" autocomplete="organization">
                </mat-form-field>
                
              </div>

              <mat-form-field class="flex-grow">
                <mat-label>{{getAlternativePlaceholder('Etternavn', true)}}</mat-label>
                <!-- husk alternative label her -->
                <input matInput [placeholder]="getAlternativePlaceholder('Etternavn', true)" formControlName="lastName"
                  autocomplete="family-name">
                <mat-error>{{getAlternativePlaceholder('Etternavn', true)}} er et obligatorisk felt</mat-error>
              </mat-form-field>
            </div>

            <!-- adresse/kontaktinfo -->
            <div class="flex-row flex-gap-20">

              <!-- adresse/kontaktinfo -->
              <div class="flex-column flex-half flex-gap-10">

                <mat-form-field class="flex-grow" *ngIf="caseForm?.controls?.countryCodeAlpha2?.value !== 'NO'">
                  <mat-label>Utenlandsk adresse</mat-label>
                  <textarea style="height:107px;" matInput placeholder="F.eks. 100 Main St"
                    formControlName="address"></textarea>
                  <mat-error
                    *ngIf="caseForm?.controls?.address?.errors && caseForm?.controls?.address?.errors?.required">Adresse
                    er et obligatorisk felt</mat-error>
                  <mat-error
                    *ngIf="caseForm?.controls?.address?.errors && caseForm?.controls?.address?.errors?.maxlength">Adresse
                    kan maksimalt inneholde {{caseForm.controls.address.errors?.maxlength.requiredLength}}
                    tegn</mat-error>
                </mat-form-field>

                <mat-form-field class="flex-grow" *ngIf="caseForm?.controls?.countryCodeAlpha2?.value === 'NO'">
                  <mat-label>Adresse</mat-label> <!-- husk alternative label her -->
                  <input matInput formControlName="address" autocomplete="street-address">
                  <mat-error
                    *ngIf="caseForm?.controls?.address?.errors && caseForm?.controls?.address?.errors?.required">Adresse
                    er et obligatorisk felt</mat-error>
                  <mat-error
                    *ngIf="caseForm?.controls?.address?.errors && caseForm?.controls?.address?.errors?.maxlength">Adresse
                    kan maksimalt inneholde {{caseForm.controls.address.errors?.maxlength.requiredLength}}
                    tegn</mat-error>
                </mat-form-field>

                <div class="flex-row flex-gap-10" *ngIf="caseForm.controls?.countryCodeAlpha2?.value === 'NO'">
                  <mat-form-field style="flex: 0 1 100px">
                    <mat-label>Postnr</mat-label> <!-- husk alternative label her -->
                    <input matInput [placeholder]="'Postnr'" formControlName="postalCode" autocomplete="postal-code">
                    <mat-error>Postnr er et obligatorisk felt</mat-error>
                  </mat-form-field>

                  <mat-form-field class="flex-grow">
                    <mat-label>Poststed</mat-label> <!-- husk alternative label her -->
                    <input matInput [placeholder]="'Poststed'" formControlName="postalPlace">
                    <mat-error>Poststed er et obligatorisk felt</mat-error>
                  </mat-form-field>
                </div>

                <!-- husk alternative label her -->
                <mat-form-field class="flex-grow">
                  <mat-label>Land</mat-label>
                  <mat-select formControlName="countryCodeAlpha2">
                    <mat-option *ngFor="let countryCode of filteredCountries | async" [value]="countryCode.cca2">
                      {{countryCode.name.common}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>

              <!-- Kontaktinformasjon -->
              <div class="flex-column flex-half flex-gap-10">

                <div class="flex-row flex-gap-10">
                  <mat-form-field style="flex: 0 1 180px">
                    <mat-label>Landkode</mat-label>
                    <mat-select formControlName="phoneCountryCodeAlpha2">
                      <mat-select-trigger>
                        {{getPhoneDisplayValueFromCountryCode(caseForm.controls['phoneCountryCodeAlpha2'].value,
                        false)}}
                      </mat-select-trigger>
                      <mat-option *ngFor="let country of filteredCountries | async" [value]="country.cca2">
                        {{getPhoneDisplayValueFromCountryCode(country.cca2, true)}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="flex-grow">
                    <mat-label>Telefon/mobil</mat-label>
                    <input matInput placeholder="Telefon/mobil" formControlName="phone" autocomplete="tel">
                    <mat-error *ngIf="caseForm.controls.phone?.errors?.phoneFormatError">Ugyldig
                      telefonnummer</mat-error>
                    <mat-error *ngIf="caseForm.controls.phone?.errors?.required">Telefonnummer er et
                      obligatorisk felt</mat-error>

                  </mat-form-field>
                </div>

                <mat-form-field class="flex-row">
                  <mat-label>E-postadresse</mat-label> <!-- husk alternative label her -->
                  <input matInput [placeholder]="'E-postadresse'" formControlName="email" autocomplete="email">
                  <mat-error
                    *ngIf="caseForm.controls.email?.errors && caseForm.controls.email?.errors?.required">E-postadresse
                    er et obligatorisk felt</mat-error>
                  <mat-error *ngIf="caseForm.controls.email?.errors && caseForm.controls.email?.errors?.email">Ugyldig
                    e-postadresse</mat-error>
                  <mat-error
                    *ngIf="caseForm.controls.email?.errors && caseForm.controls.email?.errors?.maxlength">E-postadresse
                    kan maksimalt inneholde {{caseForm.controls.email.errors?.maxlength.requiredLength}} tegn
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="flex-row">
                  <mat-label>Din referanse</mat-label>
                  <input matInput formControlName="reference" autocomplete="off">
                </mat-form-field>

              </div>

            </div>

            <div class="flex-row flex-gap-20">

              <button
                *ngIf="((!case?.IsComplainer && !case?.HasComplainerKey) || case?.IsComplainer) && !editModeComplainer"
                style="flex: 0 1 150px" class="finkn-btn" color="primary" mat-raised-button type="button"
                (click)="toggleEditModeComplainer(true)">Endre</button>

              <div class="flex-grow flex-row flex-gap-20" *ngIf="editModeComplainer">
                <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                  (click)="saveComplainer()">Lagre</button>
                <button style="flex: 0 1 150px" type="button" class="finkn-btn" color="primary" mat-raised-button
                  (click)="cancelEditModeComplainer()">Avbryt</button>
              </div>

              <!-- <button
                *ngIf="!case?.IsComplainer && !case?.HasComplainerKey && !editModeComplainer"
                class="finkn-btn" color="primary" mat-raised-button type="button" (click)="inviteComplainer()">Inviter
                klager til Min sak</button> -->

              <div class="flex-grow flex-row flex-gap-20">
                <button *ngIf="!editModeComplainer && !case?.HasCorrespondent" type="button" class="finkn-btn"
                  color="primary" mat-raised-button (click)="addContact()">Legg til kontaktperson
                </button>

              </div>

            </div>


          </div>
        </mat-card-content>
      </mat-card>

      <!-- OPPLYSNINGER OM FINANSFORETAK -->
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{getLabelValue('CaseDetailsCompany') | striphtml}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="flex-grow flex-row flex-gap-20">

            <div class="flex-grow flex-column flex-gap-5">
              <label><strong>Finansforetak</strong></label>
              <span>{{case.CompanyName}}</span>
            </div>

            <div class="flex-grow flex-column flex-gap-5">
              <label><strong>Ref</strong></label>
              <span>{{case.CompanyCaseRef}}</span>
            </div>

          </div>
        </mat-card-content>
      </mat-card>

      <!-- HENDELSER (7) DOKUMENTER I DIN SAK (13) -->
      <app-case-events></app-case-events>

    </div>
  </form>

</div>